module.exports = __webpack_public_path__ + "static/media/CT_2019_30439A.85b0aeb8.png";